const D = /* @__PURE__ */ new WeakMap();
function V(e, t, i, n) {
  if (!e && !D.has(t)) return false;
  const r = D.get(t) ?? /* @__PURE__ */ new WeakMap();
  D.set(t, r);
  const s = r.get(i) ?? /* @__PURE__ */ new Set();
  r.set(i, s);
  const o = s.has(n);
  return e ? s.add(n) : s.delete(n), o && e;
}
function Z(e, t) {
  let i = e.target;
  if (i instanceof Text && (i = i.parentElement), i instanceof Element && e.currentTarget instanceof Node) {
    const n = i.closest(t);
    if (n && e.currentTarget.contains(n)) return n;
  }
}
function tt(e, t, i, n = {}) {
  const { signal: r, base: s = document } = n;
  if (r == null ? void 0 : r.aborted) return;
  const { once: o, ...a } = n, c = s instanceof Document ? s.documentElement : s, h = !!(typeof n == "object" ? n.capture : n), l = (f) => {
    const g = Z(f, String(e));
    if (g) {
      const v = Object.assign(f, { delegateTarget: g });
      i.call(c, v), o && (c.removeEventListener(t, l, a), V(false, c, i, u));
    }
  }, u = JSON.stringify({ selector: e, type: t, capture: h });
  V(true, c, i, u) || c.addEventListener(t, l, a), r == null ? void 0 : r.addEventListener("abort", () => {
    V(false, c, i, u);
  });
}
function et(e) {
  for (var t = [], i = 0; i < e.length; ) {
    var n = e[i];
    if (n === "*" || n === "+" || n === "?") {
      t.push({ type: "MODIFIER", index: i, value: e[i++] });
      continue;
    }
    if (n === "\\") {
      t.push({ type: "ESCAPED_CHAR", index: i++, value: e[i++] });
      continue;
    }
    if (n === "{") {
      t.push({ type: "OPEN", index: i, value: e[i++] });
      continue;
    }
    if (n === "}") {
      t.push({ type: "CLOSE", index: i, value: e[i++] });
      continue;
    }
    if (n === ":") {
      for (var r = "", s = i + 1; s < e.length; ) {
        var o = e.charCodeAt(s);
        if (o >= 48 && o <= 57 || o >= 65 && o <= 90 || o >= 97 && o <= 122 || o === 95) {
          r += e[s++];
          continue;
        }
        break;
      }
      if (!r) throw new TypeError("Missing parameter name at ".concat(i));
      t.push({ type: "NAME", index: i, value: r }), i = s;
      continue;
    }
    if (n === "(") {
      var a = 1, c = "", s = i + 1;
      if (e[s] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(s));
      for (; s < e.length; ) {
        if (e[s] === "\\") {
          c += e[s++] + e[s++];
          continue;
        }
        if (e[s] === ")") {
          if (a--, a === 0) {
            s++;
            break;
          }
        } else if (e[s] === "(" && (a++, e[s + 1] !== "?")) throw new TypeError("Capturing groups are not allowed at ".concat(s));
        c += e[s++];
      }
      if (a) throw new TypeError("Unbalanced pattern at ".concat(i));
      if (!c) throw new TypeError("Missing pattern at ".concat(i));
      t.push({ type: "PATTERN", index: i, value: c }), i = s;
      continue;
    }
    t.push({ type: "CHAR", index: i, value: e[i++] });
  }
  return t.push({ type: "END", index: i, value: "" }), t;
}
function it(e, t) {
  t === void 0 && (t = {});
  for (var i = et(e), n = t.prefixes, r = n === void 0 ? "./" : n, s = t.delimiter, o = s === void 0 ? "/#?" : s, a = [], c = 0, h = 0, l = "", u = function(k) {
    if (h < i.length && i[h].type === k) return i[h++].value;
  }, d = function(k) {
    var E = u(k);
    if (E !== void 0) return E;
    var S = i[h], M = S.type, Y = S.index;
    throw new TypeError("Unexpected ".concat(M, " at ").concat(Y, ", expected ").concat(k));
  }, f = function() {
    for (var k = "", E; E = u("CHAR") || u("ESCAPED_CHAR"); ) k += E;
    return k;
  }, g = function(k) {
    for (var E = 0, S = o; E < S.length; E++) {
      var M = S[E];
      if (k.indexOf(M) > -1) return true;
    }
    return false;
  }, v = function(k) {
    var E = a[a.length - 1], S = k || (E && typeof E == "string" ? E : "");
    if (E && !S) throw new TypeError('Must have text between two parameters, missing text after "'.concat(E.name, '"'));
    return !S || g(S) ? "[^".concat(T(o), "]+?") : "(?:(?!".concat(T(S), ")[^").concat(T(o), "])+?");
  }; h < i.length; ) {
    var y = u("CHAR"), m = u("NAME"), b = u("PATTERN");
    if (m || b) {
      var x = y || "";
      r.indexOf(x) === -1 && (l += x, x = ""), l && (a.push(l), l = ""), a.push({ name: m || c++, prefix: x, suffix: "", pattern: b || v(x), modifier: u("MODIFIER") || "" });
      continue;
    }
    var p = y || u("ESCAPED_CHAR");
    if (p) {
      l += p;
      continue;
    }
    l && (a.push(l), l = "");
    var P = u("OPEN");
    if (P) {
      var x = f(), A = u("NAME") || "", U = u("PATTERN") || "", R = f();
      d("CLOSE"), a.push({ name: A || (U ? c++ : ""), pattern: A && !U ? v(x) : U, prefix: x, suffix: R, modifier: u("MODIFIER") || "" });
      continue;
    }
    d("END");
  }
  return a;
}
function nt(e, t) {
  var i = [], n = z(e, i, t);
  return st(n, i, t);
}
function st(e, t, i) {
  i === void 0 && (i = {});
  var n = i.decode, r = n === void 0 ? function(s) {
    return s;
  } : n;
  return function(s) {
    var o = e.exec(s);
    if (!o) return false;
    for (var a = o[0], c = o.index, h = /* @__PURE__ */ Object.create(null), l = function(d) {
      if (o[d] === void 0) return "continue";
      var f = t[d - 1];
      f.modifier === "*" || f.modifier === "+" ? h[f.name] = o[d].split(f.prefix + f.suffix).map(function(g) {
        return r(g, f);
      }) : h[f.name] = r(o[d], f);
    }, u = 1; u < o.length; u++) l(u);
    return { path: a, index: c, params: h };
  };
}
function T(e) {
  return e.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function K(e) {
  return e && e.sensitive ? "" : "i";
}
function rt(e, t) {
  if (!t) return e;
  for (var i = /\((?:\?<(.*?)>)?(?!\?)/g, n = 0, r = i.exec(e.source); r; ) t.push({ name: r[1] || n++, prefix: "", suffix: "", modifier: "", pattern: "" }), r = i.exec(e.source);
  return e;
}
function ot(e, t, i) {
  var n = e.map(function(r) {
    return z(r, t, i).source;
  });
  return new RegExp("(?:".concat(n.join("|"), ")"), K(i));
}
function at(e, t, i) {
  return lt(it(e, i), t, i);
}
function lt(e, t, i) {
  i === void 0 && (i = {});
  for (var n = i.strict, r = n === void 0 ? false : n, s = i.start, o = s === void 0 ? true : s, a = i.end, c = a === void 0 ? true : a, h = i.encode, l = h === void 0 ? function(E) {
    return E;
  } : h, u = i.delimiter, d = u === void 0 ? "/#?" : u, f = i.endsWith, g = f === void 0 ? "" : f, v = "[".concat(T(g), "]|$"), y = "[".concat(T(d), "]"), m = o ? "^" : "", b = 0, x = e; b < x.length; b++) {
    var p = x[b];
    if (typeof p == "string") m += T(l(p));
    else {
      var P = T(l(p.prefix)), A = T(l(p.suffix));
      if (p.pattern) if (t && t.push(p), P || A) if (p.modifier === "+" || p.modifier === "*") {
        var U = p.modifier === "*" ? "?" : "";
        m += "(?:".concat(P, "((?:").concat(p.pattern, ")(?:").concat(A).concat(P, "(?:").concat(p.pattern, "))*)").concat(A, ")").concat(U);
      } else m += "(?:".concat(P, "(").concat(p.pattern, ")").concat(A, ")").concat(p.modifier);
      else {
        if (p.modifier === "+" || p.modifier === "*") throw new TypeError('Can not repeat "'.concat(p.name, '" without a prefix and suffix'));
        m += "(".concat(p.pattern, ")").concat(p.modifier);
      }
      else m += "(?:".concat(P).concat(A, ")").concat(p.modifier);
    }
  }
  if (c) r || (m += "".concat(y, "?")), m += i.endsWith ? "(?=".concat(v, ")") : "$";
  else {
    var R = e[e.length - 1], k = typeof R == "string" ? y.indexOf(R[R.length - 1]) > -1 : R === void 0;
    r || (m += "(?:".concat(y, "(?=").concat(v, "))?")), k || (m += "(?=".concat(y, "|").concat(v, ")"));
  }
  return new RegExp(m, K(i));
}
function z(e, t, i) {
  return e instanceof RegExp ? rt(e, t) : Array.isArray(e) ? ot(e, t, i) : at(e, t, i);
}
function w() {
  return w = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i) ({}).hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, w.apply(null, arguments);
}
const G = (e, t) => String(e).toLowerCase().replace(/[\s/_.]+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+|-+$/g, "") || t || "", H = ({ hash: e } = {}) => window.location.pathname + window.location.search + (e ? window.location.hash : ""), ct = (e, t = {}) => {
  const i = w({ url: e = e || H({ hash: true }), random: Math.random(), source: "swup" }, t);
  window.history.pushState(i, "", e);
}, $ = (e = null, t = {}) => {
  e = e || H({ hash: true });
  const i = w({}, window.history.state || {}, { url: e, random: Math.random(), source: "swup" }, t);
  window.history.replaceState(i, "", e);
}, ht = (e, t, i, n) => {
  const r = new AbortController();
  return n = w({}, n, { signal: r.signal }), tt(e, t, i, n), { destroy: () => r.abort() };
};
let C = class I extends URL {
  constructor(t, i = document.baseURI) {
    super(t.toString(), i), Object.setPrototypeOf(this, I.prototype);
  }
  get url() {
    return this.pathname + this.search;
  }
  static fromElement(t) {
    const i = t.getAttribute("href") || t.getAttribute("xlink:href") || "";
    return new I(i);
  }
  static fromUrl(t) {
    return new I(t);
  }
};
const Ht = (e, t) => {
  Array.isArray(e) && !e.length && (e = "");
  try {
    return nt(e, t);
  } catch (i) {
    throw new Error(`[swup] Error parsing path "${String(e)}":
${String(i)}`);
  }
};
class O extends Error {
  constructor(t, i) {
    super(t), this.url = void 0, this.status = void 0, this.aborted = void 0, this.timedOut = void 0, this.name = "FetchError", this.url = i.url, this.status = i.status, this.aborted = i.aborted || false, this.timedOut = i.timedOut || false;
  }
}
async function ut(e, t = {}) {
  var i;
  e = C.fromUrl(e).url;
  const { visit: n = this.visit } = t, r = w({}, this.options.requestHeaders, t.headers), s = (i = t.timeout) != null ? i : this.options.timeout, o = new AbortController(), { signal: a } = o;
  t = w({}, t, { headers: r, signal: a });
  let c, h = false, l = null;
  s && s > 0 && (l = setTimeout(() => {
    h = true, o.abort("timeout");
  }, s));
  try {
    c = await this.hooks.call("fetch:request", n, { url: e, options: t }, (y, { url: m, options: b }) => fetch(m, b)), l && clearTimeout(l);
  } catch (y) {
    throw h ? (this.hooks.call("fetch:timeout", n, { url: e }), new O(`Request timed out: ${e}`, { url: e, timedOut: h })) : (y == null ? void 0 : y.name) === "AbortError" || a.aborted ? new O(`Request aborted: ${e}`, { url: e, aborted: true }) : y;
  }
  const { status: u, url: d } = c, f = await c.text();
  if (u === 500) throw this.hooks.call("fetch:error", n, { status: u, response: c, url: d }), new O(`Server error: ${d}`, { status: u, url: d });
  if (!f) throw new O(`Empty response: ${d}`, { status: u, url: d });
  const { url: g } = C.fromUrl(d), v = { url: g, html: f };
  return !n.cache.write || t.method && t.method !== "GET" || e !== g || this.cache.set(v.url, v), v;
}
class dt {
  constructor(t) {
    this.swup = void 0, this.pages = /* @__PURE__ */ new Map(), this.swup = t;
  }
  get size() {
    return this.pages.size;
  }
  get all() {
    const t = /* @__PURE__ */ new Map();
    return this.pages.forEach((i, n) => {
      t.set(n, w({}, i));
    }), t;
  }
  has(t) {
    return this.pages.has(this.resolve(t));
  }
  get(t) {
    const i = this.pages.get(this.resolve(t));
    return i && w({}, i);
  }
  set(t, i) {
    i = w({}, i, { url: t = this.resolve(t) }), this.pages.set(t, i), this.swup.hooks.callSync("cache:set", void 0, { page: i });
  }
  update(t, i) {
    t = this.resolve(t);
    const n = w({}, this.get(t), i, { url: t });
    this.pages.set(t, n);
  }
  delete(t) {
    this.pages.delete(this.resolve(t));
  }
  clear() {
    this.pages.clear(), this.swup.hooks.callSync("cache:clear", void 0, void 0);
  }
  prune(t) {
    this.pages.forEach((i, n) => {
      t(n, i) && this.delete(n);
    });
  }
  resolve(t) {
    const { url: i } = C.fromUrl(t);
    return this.swup.resolveUrl(i);
  }
}
const W = (e, t = document) => t.querySelector(e), _ = (e, t = document) => Array.from(t.querySelectorAll(e)), J = () => new Promise((e) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      e();
    });
  });
});
function X(e) {
  return !!e && (typeof e == "object" || typeof e == "function") && typeof e.then == "function";
}
function ft(e, t = []) {
  return new Promise((i, n) => {
    const r = e(...t);
    X(r) ? r.then(i, n) : i(r);
  });
}
function j(e, t) {
  const i = e == null ? void 0 : e.closest(`[${t}]`);
  return i != null && i.hasAttribute(t) ? (i == null ? void 0 : i.getAttribute(t)) || true : void 0;
}
class pt {
  constructor(t) {
    this.swup = void 0, this.swupClasses = ["to-", "is-changing", "is-rendering", "is-popstate", "is-animating", "is-leaving"], this.swup = t;
  }
  get selectors() {
    const { scope: t } = this.swup.visit.animation;
    return t === "containers" ? this.swup.visit.containers : t === "html" ? ["html"] : Array.isArray(t) ? t : [];
  }
  get selector() {
    return this.selectors.join(",");
  }
  get targets() {
    return this.selector.trim() ? _(this.selector) : [];
  }
  add(...t) {
    this.targets.forEach((i) => i.classList.add(...t));
  }
  remove(...t) {
    this.targets.forEach((i) => i.classList.remove(...t));
  }
  clear() {
    this.targets.forEach((t) => {
      const i = t.className.split(" ").filter((n) => this.isSwupClass(n));
      t.classList.remove(...i);
    });
  }
  isSwupClass(t) {
    return this.swupClasses.some((i) => t.startsWith(i));
  }
}
class Q {
  constructor(t, i) {
    this.id = void 0, this.state = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.animation = void 0, this.trigger = void 0, this.cache = void 0, this.history = void 0, this.scroll = void 0, this.meta = void 0;
    const { to: n, from: r, hash: s, el: o, event: a } = i;
    this.id = Math.random(), this.state = 1, this.from = { url: r ?? t.location.url, hash: t.location.hash }, this.to = { url: n, hash: s }, this.containers = t.options.containers, this.animation = { animate: true, wait: false, name: void 0, native: t.options.native, scope: t.options.animationScope, selector: t.options.animationSelector }, this.trigger = { el: o, event: a }, this.cache = { read: t.options.cache, write: t.options.cache }, this.history = { action: "push", popstate: false, direction: void 0 }, this.scroll = { reset: true, target: void 0 }, this.meta = {};
  }
  advance(t) {
    this.state < t && (this.state = t);
  }
  abort() {
    this.state = 8;
  }
  get done() {
    return this.state >= 7;
  }
}
function vt(e) {
  return new Q(this, e);
}
class mt {
  constructor(t) {
    this.swup = void 0, this.registry = /* @__PURE__ */ new Map(), this.hooks = ["animation:out:start", "animation:out:await", "animation:out:end", "animation:in:start", "animation:in:await", "animation:in:end", "animation:skip", "cache:clear", "cache:set", "content:replace", "content:scroll", "enable", "disable", "fetch:request", "fetch:error", "fetch:timeout", "history:popstate", "link:click", "link:self", "link:anchor", "link:newtab", "page:load", "page:view", "scroll:top", "scroll:anchor", "visit:start", "visit:transition", "visit:abort", "visit:end"], this.swup = t, this.init();
  }
  init() {
    this.hooks.forEach((t) => this.create(t));
  }
  create(t) {
    this.registry.has(t) || this.registry.set(t, /* @__PURE__ */ new Map());
  }
  exists(t) {
    return this.registry.has(t);
  }
  get(t) {
    const i = this.registry.get(t);
    if (i) return i;
    console.error(`Unknown hook '${t}'`);
  }
  clear() {
    this.registry.forEach((t) => t.clear());
  }
  on(t, i, n = {}) {
    const r = this.get(t);
    if (!r) return console.warn(`Hook '${t}' not found.`), () => {
    };
    const s = w({}, n, { id: r.size + 1, hook: t, handler: i });
    return r.set(i, s), () => this.off(t, i);
  }
  before(t, i, n = {}) {
    return this.on(t, i, w({}, n, { before: true }));
  }
  replace(t, i, n = {}) {
    return this.on(t, i, w({}, n, { replace: true }));
  }
  once(t, i, n = {}) {
    return this.on(t, i, w({}, n, { once: true }));
  }
  off(t, i) {
    const n = this.get(t);
    n && i ? n.delete(i) || console.warn(`Handler for hook '${t}' not found.`) : n && n.clear();
  }
  async call(t, i, n, r) {
    const [s, o, a] = this.parseCallArgs(t, i, n, r), { before: c, handler: h, after: l } = this.getHandlers(t, a);
    await this.run(c, s, o);
    const [u] = await this.run(h, s, o, true);
    return await this.run(l, s, o), this.dispatchDomEvent(t, s, o), u;
  }
  callSync(t, i, n, r) {
    const [s, o, a] = this.parseCallArgs(t, i, n, r), { before: c, handler: h, after: l } = this.getHandlers(t, a);
    this.runSync(c, s, o);
    const [u] = this.runSync(h, s, o, true);
    return this.runSync(l, s, o), this.dispatchDomEvent(t, s, o), u;
  }
  parseCallArgs(t, i, n, r) {
    return i instanceof Q || typeof i != "object" && typeof n != "function" ? [i, n, r] : [void 0, i, n];
  }
  async run(t, i = this.swup.visit, n, r = false) {
    const s = [];
    for (const { hook: o, handler: a, defaultHandler: c, once: h } of t) if (i == null || !i.done) {
      h && this.off(o, a);
      try {
        const l = await ft(a, [i, n, c]);
        s.push(l);
      } catch (l) {
        if (r) throw l;
        console.error(`Error in hook '${o}':`, l);
      }
    }
    return s;
  }
  runSync(t, i = this.swup.visit, n, r = false) {
    const s = [];
    for (const { hook: o, handler: a, defaultHandler: c, once: h } of t) if (i == null || !i.done) {
      h && this.off(o, a);
      try {
        const l = a(i, n, c);
        s.push(l), X(l) && console.warn(`Swup will not await Promises in handler for synchronous hook '${o}'.`);
      } catch (l) {
        if (r) throw l;
        console.error(`Error in hook '${o}':`, l);
      }
    }
    return s;
  }
  getHandlers(t, i) {
    const n = this.get(t);
    if (!n) return { found: false, before: [], handler: [], after: [], replaced: false };
    const r = Array.from(n.values()), s = this.sortRegistrations, o = r.filter(({ before: u, replace: d }) => u && !d).sort(s), a = r.filter(({ replace: u }) => u).filter((u) => true).sort(s), c = r.filter(({ before: u, replace: d }) => !u && !d).sort(s), h = a.length > 0;
    let l = [];
    if (i && (l = [{ id: 0, hook: t, handler: i }], h)) {
      const u = a.length - 1, { handler: d, once: f } = a[u], g = (v) => {
        const y = a[v - 1];
        return y ? (m, b) => y.handler(m, b, g(v - 1)) : i;
      };
      l = [{ id: 0, hook: t, once: f, handler: d, defaultHandler: g(u) }];
    }
    return { found: true, before: o, handler: l, after: c, replaced: h };
  }
  sortRegistrations(t, i) {
    var n, r;
    return ((n = t.priority) != null ? n : 0) - ((r = i.priority) != null ? r : 0) || t.id - i.id || 0;
  }
  dispatchDomEvent(t, i, n) {
    if (i != null && i.done) return;
    const r = { hook: t, args: n, visit: i || this.swup.visit };
    document.dispatchEvent(new CustomEvent("swup:any", { detail: r, bubbles: true })), document.dispatchEvent(new CustomEvent(`swup:${t}`, { detail: r, bubbles: true }));
  }
  parseName(t) {
    const [i, ...n] = t.split(".");
    return [i, n.reduce((r, s) => w({}, r, { [s]: true }), {})];
  }
}
const gt = (e) => {
  if (e && e.charAt(0) === "#" && (e = e.substring(1)), !e) return null;
  const t = decodeURIComponent(e);
  let i = document.getElementById(e) || document.getElementById(t) || W(`a[name='${CSS.escape(e)}']`) || W(`a[name='${CSS.escape(t)}']`);
  return i || e !== "top" || (i = document.body), i;
}, N = "transition", q = "animation";
async function wt({ selector: e, elements: t }) {
  if (e === false && !t) return;
  let i = [];
  if (t) i = Array.from(t);
  else if (e && (i = _(e, document.body), !i.length)) return void console.warn(`[swup] No elements found matching animationSelector \`${e}\``);
  const n = i.map((r) => (function(s) {
    const { type: o, timeout: a, propCount: c } = (function(h) {
      const l = window.getComputedStyle(h), u = L(l, `${N}Delay`), d = L(l, `${N}Duration`), f = B(u, d), g = L(l, `${q}Delay`), v = L(l, `${q}Duration`), y = B(g, v), m = Math.max(f, y), b = m > 0 ? f > y ? N : q : null;
      return { type: b, timeout: m, propCount: b ? b === N ? d.length : v.length : 0 };
    })(s);
    return !(!o || !a) && new Promise((h) => {
      const l = `${o}end`, u = performance.now();
      let d = 0;
      const f = () => {
        s.removeEventListener(l, g), h();
      }, g = (v) => {
        v.target === s && ((performance.now() - u) / 1e3 < v.elapsedTime || ++d >= c && f());
      };
      setTimeout(() => {
        d < c && f();
      }, a + 1), s.addEventListener(l, g);
    });
  })(r));
  n.filter(Boolean).length > 0 ? await Promise.all(n) : e && console.warn(`[swup] No CSS animation duration defined on elements matching \`${e}\``);
}
function L(e, t) {
  return (e[t] || "").split(", ");
}
function B(e, t) {
  for (; e.length < t.length; ) e = e.concat(e);
  return Math.max(...t.map((i, n) => F(i) + F(e[n])));
}
function F(e) {
  return 1e3 * parseFloat(e);
}
function yt(e, t = {}, i = {}) {
  if (typeof e != "string") throw new Error("swup.navigate() requires a URL parameter");
  if (this.shouldIgnoreVisit(e, { el: i.el, event: i.event })) return void window.location.assign(e);
  const { url: n, hash: r } = C.fromUrl(e), s = this.createVisit(w({}, i, { to: n, hash: r }));
  this.performNavigation(s, t);
}
async function Et(e, t = {}) {
  if (this.navigating) {
    if (this.visit.state >= 6) return e.state = 2, void (this.onVisitEnd = () => this.performNavigation(e, t));
    await this.hooks.call("visit:abort", this.visit, void 0), delete this.visit.to.document, this.visit.state = 8;
  }
  this.navigating = true, this.visit = e;
  const { el: i } = e.trigger;
  t.referrer = t.referrer || this.location.url, t.animate === false && (e.animation.animate = false), e.animation.animate || this.classes.clear();
  const n = t.history || j(i, "data-swup-history");
  typeof n == "string" && ["push", "replace"].includes(n) && (e.history.action = n);
  const r = t.animation || j(i, "data-swup-animation");
  var s, o;
  typeof r == "string" && (e.animation.name = r), e.meta = t.meta || {}, typeof t.cache == "object" ? (e.cache.read = (s = t.cache.read) != null ? s : e.cache.read, e.cache.write = (o = t.cache.write) != null ? o : e.cache.write) : t.cache !== void 0 && (e.cache = { read: !!t.cache, write: !!t.cache }), delete t.cache;
  try {
    await this.hooks.call("visit:start", e, void 0), e.state = 3;
    const a = this.hooks.call("page:load", e, { options: t }, async (h, l) => {
      let u;
      return h.cache.read && (u = this.cache.get(h.to.url)), l.page = u || await this.fetchPage(h.to.url, l.options), l.cache = !!u, l.page;
    });
    a.then(({ html: h }) => {
      e.advance(5), e.to.html = h, e.to.document = new DOMParser().parseFromString(h, "text/html");
    });
    const c = e.to.url + e.to.hash;
    if (e.history.popstate || (e.history.action === "replace" || e.to.url === this.location.url ? $(c) : (this.currentHistoryIndex++, ct(c, { index: this.currentHistoryIndex }))), this.location = C.fromUrl(c), e.history.popstate && this.classes.add("is-popstate"), e.animation.name && this.classes.add(`to-${G(e.animation.name)}`), e.animation.wait && await a, e.done || (await this.hooks.call("visit:transition", e, void 0, async () => {
      if (!e.animation.animate) return await this.hooks.call("animation:skip", void 0), void await this.renderPage(e, await a);
      e.advance(4), await this.animatePageOut(e), e.animation.native && document.startViewTransition ? await document.startViewTransition(async () => await this.renderPage(e, await a)).finished : await this.renderPage(e, await a), await this.animatePageIn(e);
    }), e.done)) return;
    await this.hooks.call("visit:end", e, void 0, () => this.classes.clear()), e.state = 7, this.navigating = false, this.onVisitEnd && (this.onVisitEnd(), this.onVisitEnd = void 0);
  } catch (a) {
    if (!a || a != null && a.aborted) return void (e.state = 8);
    e.state = 9, console.error(a), this.options.skipPopStateHandling = () => (window.location.assign(e.to.url + e.to.hash), true), window.history.back();
  } finally {
    delete e.to.document;
  }
}
const bt = async function(e) {
  await this.hooks.call("animation:out:start", e, void 0, () => {
    this.classes.add("is-changing", "is-animating", "is-leaving");
  }), await this.hooks.call("animation:out:await", e, { skip: false }, (t, { skip: i }) => {
    if (!i) return this.awaitAnimations({ selector: t.animation.selector });
  }), await this.hooks.call("animation:out:end", e, void 0);
}, kt = function(e) {
  var t;
  const i = e.to.document;
  if (!i) return false;
  const n = ((t = i.querySelector("title")) == null ? void 0 : t.innerText) || "";
  document.title = n;
  const r = _('[data-swup-persist]:not([data-swup-persist=""])'), s = e.containers.map((o) => {
    const a = document.querySelector(o), c = i.querySelector(o);
    return a && c ? (a.replaceWith(c.cloneNode(true)), true) : (a || console.warn(`[swup] Container missing in current document: ${o}`), c || console.warn(`[swup] Container missing in incoming document: ${o}`), false);
  }).filter(Boolean);
  return r.forEach((o) => {
    const a = o.getAttribute("data-swup-persist"), c = W(`[data-swup-persist="${a}"]`);
    c && c !== o && c.replaceWith(o);
  }), s.length === e.containers.length;
}, xt = function(e) {
  const t = { behavior: "auto" }, { target: i, reset: n } = e.scroll, r = i ?? e.to.hash;
  let s = false;
  return r && (s = this.hooks.callSync("scroll:anchor", e, { hash: r, options: t }, (o, { hash: a, options: c }) => {
    const h = this.getAnchorElement(a);
    return h && h.scrollIntoView(c), !!h;
  })), n && !s && (s = this.hooks.callSync("scroll:top", e, { options: t }, (o, { options: a }) => (window.scrollTo(w({ top: 0, left: 0 }, a)), true))), s;
}, St = async function(e) {
  if (e.done) return;
  const t = this.hooks.call("animation:in:await", e, { skip: false }, (i, { skip: n }) => {
    if (!n) return this.awaitAnimations({ selector: i.animation.selector });
  });
  await J(), await this.hooks.call("animation:in:start", e, void 0, () => {
    this.classes.remove("is-animating");
  }), await t, await this.hooks.call("animation:in:end", e, void 0);
}, Ct = async function(e, t) {
  if (e.done) return;
  e.advance(6);
  const { url: i } = t;
  this.isSameResolvedUrl(H(), i) || ($(i), this.location = C.fromUrl(i), e.to.url = this.location.url, e.to.hash = this.location.hash), await this.hooks.call("content:replace", e, { page: t }, (n, {}) => {
    if (this.classes.remove("is-leaving"), n.animation.animate && this.classes.add("is-rendering"), !this.replaceContent(n)) throw new Error("[swup] Container mismatch, aborting");
    n.animation.animate && (this.classes.add("is-changing", "is-animating", "is-rendering"), n.animation.name && this.classes.add(`to-${G(n.animation.name)}`));
  }), await this.hooks.call("content:scroll", e, void 0, () => this.scrollToContent(e)), await this.hooks.call("page:view", e, { url: this.location.url, title: document.title });
}, At = function(e) {
  var t;
  if (t = e, !!(t == null ? void 0 : t.isSwupPlugin)) {
    if (e.swup = this, !e._checkRequirements || e._checkRequirements()) return e._beforeMount && e._beforeMount(), e.mount(), this.plugins.push(e), this.plugins;
  } else console.error("Not a swup plugin instance", e);
};
function Tt(e) {
  const t = this.findPlugin(e);
  if (t) return t.unmount(), t._afterUnmount && t._afterUnmount(), this.plugins = this.plugins.filter((i) => i !== t), this.plugins;
  console.error("No such plugin", t);
}
function Pt(e) {
  return this.plugins.find((t) => t === e || t.name === e || t.name === `Swup${String(e)}`);
}
function Rt(e) {
  if (typeof this.options.resolveUrl != "function") return console.warn("[swup] options.resolveUrl expects a callback function."), e;
  const t = this.options.resolveUrl(e);
  return t && typeof t == "string" ? t.startsWith("//") || t.startsWith("http") ? (console.warn("[swup] options.resolveUrl needs to return a relative url"), e) : t : (console.warn("[swup] options.resolveUrl needs to return a url"), e);
}
function Ut(e, t) {
  return this.resolveUrl(e) === this.resolveUrl(t);
}
const $t = { animateHistoryBrowsing: false, animationSelector: '[class*="transition-"]', animationScope: "html", cache: true, containers: ["#swup"], hooks: {}, ignoreVisit: (e, { el: t } = {}) => !(t == null || !t.closest("[data-no-swup]")), linkSelector: "a[href]", linkToSelf: "scroll", native: false, plugins: [], resolveUrl: (e) => e, requestHeaders: { "X-Requested-With": "swup", Accept: "text/html, application/xhtml+xml" }, skipPopStateHandling: (e) => {
  var t;
  return ((t = e.state) == null ? void 0 : t.source) !== "swup";
}, timeout: 0 };
class Ot {
  get currentPageUrl() {
    return this.location.url;
  }
  constructor(t = {}) {
    var i, n;
    this.version = "4.8.2", this.options = void 0, this.defaults = $t, this.plugins = [], this.visit = void 0, this.cache = void 0, this.hooks = void 0, this.classes = void 0, this.location = C.fromUrl(window.location.href), this.currentHistoryIndex = void 0, this.clickDelegate = void 0, this.navigating = false, this.onVisitEnd = void 0, this.use = At, this.unuse = Tt, this.findPlugin = Pt, this.log = () => {
    }, this.navigate = yt, this.performNavigation = Et, this.createVisit = vt, this.delegateEvent = ht, this.fetchPage = ut, this.awaitAnimations = wt, this.renderPage = Ct, this.replaceContent = kt, this.animatePageIn = St, this.animatePageOut = bt, this.scrollToContent = xt, this.getAnchorElement = gt, this.getCurrentUrl = H, this.resolveUrl = Rt, this.isSameResolvedUrl = Ut, this.options = w({}, this.defaults, t), this.handleLinkClick = this.handleLinkClick.bind(this), this.handlePopState = this.handlePopState.bind(this), this.cache = new dt(this), this.classes = new pt(this), this.hooks = new mt(this), this.visit = this.createVisit({ to: "" }), this.currentHistoryIndex = (i = (n = window.history.state) == null ? void 0 : n.index) != null ? i : 1, this.enable();
  }
  async enable() {
    var t;
    const { linkSelector: i } = this.options;
    this.clickDelegate = this.delegateEvent(i, "click", this.handleLinkClick), window.addEventListener("popstate", this.handlePopState), this.options.animateHistoryBrowsing && (window.history.scrollRestoration = "manual"), this.options.native = this.options.native && !!document.startViewTransition, this.options.plugins.forEach((n) => this.use(n));
    for (const [n, r] of Object.entries(this.options.hooks)) {
      const [s, o] = this.hooks.parseName(n);
      this.hooks.on(s, r, o);
    }
    ((t = window.history.state) == null ? void 0 : t.source) !== "swup" && $(null, { index: this.currentHistoryIndex }), await J(), await this.hooks.call("enable", void 0, void 0, () => {
      const n = document.documentElement;
      n.classList.add("swup-enabled"), n.classList.toggle("swup-native", this.options.native);
    });
  }
  async destroy() {
    this.clickDelegate.destroy(), window.removeEventListener("popstate", this.handlePopState), this.cache.clear(), this.options.plugins.forEach((t) => this.unuse(t)), await this.hooks.call("disable", void 0, void 0, () => {
      const t = document.documentElement;
      t.classList.remove("swup-enabled"), t.classList.remove("swup-native");
    }), this.hooks.clear();
  }
  shouldIgnoreVisit(t, { el: i, event: n } = {}) {
    const { origin: r, url: s, hash: o } = C.fromUrl(t);
    return r !== window.location.origin || !(!i || !this.triggerWillOpenNewWindow(i)) || !!this.options.ignoreVisit(s + o, { el: i, event: n });
  }
  handleLinkClick(t) {
    const i = t.delegateTarget, { href: n, url: r, hash: s } = C.fromElement(i);
    if (this.shouldIgnoreVisit(n, { el: i, event: t })) return;
    if (this.navigating && r === this.visit.to.url) return void t.preventDefault();
    const o = this.createVisit({ to: r, hash: s, el: i, event: t });
    t.metaKey || t.ctrlKey || t.shiftKey || t.altKey ? this.hooks.callSync("link:newtab", o, { href: n }) : t.button === 0 && this.hooks.callSync("link:click", o, { el: i, event: t }, () => {
      var a;
      const c = (a = o.from.url) != null ? a : "";
      t.preventDefault(), r && r !== c ? this.isSameResolvedUrl(r, c) || this.performNavigation(o) : s ? this.hooks.callSync("link:anchor", o, { hash: s }, () => {
        $(r + s), this.scrollToContent(o);
      }) : this.hooks.callSync("link:self", o, void 0, () => {
        this.options.linkToSelf === "navigate" ? this.performNavigation(o) : ($(r), this.scrollToContent(o));
      });
    });
  }
  handlePopState(t) {
    var i, n, r, s;
    const o = (i = (n = t.state) == null ? void 0 : n.url) != null ? i : window.location.href;
    if (this.options.skipPopStateHandling(t) || this.isSameResolvedUrl(H(), this.location.url)) return;
    const { url: a, hash: c } = C.fromUrl(o), h = this.createVisit({ to: a, hash: c, event: t });
    h.history.popstate = true;
    const l = (r = (s = t.state) == null ? void 0 : s.index) != null ? r : 0;
    l && l !== this.currentHistoryIndex && (h.history.direction = l - this.currentHistoryIndex > 0 ? "forwards" : "backwards", this.currentHistoryIndex = l), h.animation.animate = false, h.scroll.reset = false, h.scroll.target = false, this.options.animateHistoryBrowsing && (h.animation.animate = true, h.scroll.reset = true), this.hooks.callSync("history:popstate", h, { event: t }, () => {
      this.performNavigation(h);
    });
  }
  triggerWillOpenNewWindow(t) {
    return !!t.matches('[download], [target="_blank"]');
  }
}
export {
  Ot as _,
  X as f,
  Ht as h,
  C as l,
  _ as m,
  H as n,
  ct as o,
  W as p,
  G as s
};
